import React from 'react';
import { motion } from 'framer-motion';
const contents = [{
  number: '01',
  title: 'Cómo el azúcar daña tus arterias en silencio',
  description: 'El proceso exacto que convierte la glucosa alta en placas que bloquean tu corazón.'
}, {
  number: '02',
  title: 'Por qué la insulina sube años antes que la glucosa',
  description: 'La señal de alarma que tu médico no mide y que predice diabetes 10 años antes.'
}, {
  number: '03',
  title: 'Los 7 síntomas que tu médico ignora',
  description: 'Señales tempranas de daño metabólico que aparecen antes de la diabetes oficial.'
}, {
  number: '04',
  title: 'Qué comer realmente (no la pirámide)',
  description: 'La verdad sobre carbohidratos, grasas y proteínas basada en ciencia, no en lobbies.'
}, {
  number: '05',
  title: 'Cómo revertir prediabetes en 90 días',
  description: 'El protocolo exacto que funciona cuando todavía estás a tiempo de evitar medicamentos.'
}, {
  number: '06',
  title: 'El protocolo de Roderic post-bypass',
  description: 'Las estrategias que usó para recuperarse y mantener su glucosa estable después de 6 cirugías.'
}];
export function Contents() {
  return <section className="relative bg-sand py-[40px] md:py-[64px] px-6" data-id="element-43">
      {/* Section Separator */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-b from-[#0A0A0F] to-transparent opacity-10 pointer-events-none z-20" data-id="element-44"></div>

      <div className="max-w-[860px] mx-auto" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-8" data-id="element-46">
          <p className="font-mono text-[11px] tracking-[0.15em] text-cocoa uppercase mb-6 text-center" data-id="element-47">
            CONTENIDO DEL LIBRO
          </p>

          <h2 className="font-serif font-black text-[42px] md:text-[44px] leading-[1.15] text-text-primary text-center max-w-[620px] mx-auto" data-id="element-48">
            Lo que vas a entender al terminar este libro.
          </h2>
        </motion.div>

        <div className="space-y-6 max-w-[720px] mx-auto" data-id="element-49">
          {contents.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="flex gap-6" data-id="element-50">
              <span className="font-serif text-[32px] font-black text-cocoa flex-shrink-0" data-id="element-51">
                {item.number}
              </span>
              <div data-id="element-52">
                <h3 className="font-serif font-bold text-[20px] text-text-primary mb-2" data-id="element-53">
                  {item.title}
                </h3>
                <p className="font-serif font-normal text-[16px] leading-[1.7] text-text-secondary" data-id="element-54">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}